export const LANGUAGES = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
};
